var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard"},[_c('dash-side-bar'),_c('div',{staticClass:"dashboard__content"},[_c('BasicTopNotification'),(!this.$store.state.Archives.initialSearchState)?_c('archive-search'):_c('archive-results')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }